import { OllamaProvider } from "./OllamaProvider";
import { GroqProvider } from "./GroqProvider";

const PROVIDER_REGISTRY = {
  groq: GroqProvider,
  ollama: OllamaProvider,
};

const PROVIDER_PRIORITY = ["groq", "ollama"];

let providerInstances = {};

export function createProvider(id, config = {}) {
  const ProviderClass = PROVIDER_REGISTRY[id];
  if (!ProviderClass) {
    throw new Error(`Unknown provider: ${id}. Available: ${Object.keys(PROVIDER_REGISTRY).join(", ")}`);
  }
  return new ProviderClass(config);
}

export function getProvider(id, config = {}) {
  if (!providerInstances[id]) {
    providerInstances[id] = createProvider(id, config);
  }
  return providerInstances[id];
}

export function resetProviders() {
  providerInstances = {};
}

export function getAvailableProviders() {
  return PROVIDER_PRIORITY.map((id) => ({
    id,
    name: PROVIDER_REGISTRY[id]?.prototype?.constructor?.name || id,
    instance: getProvider(id),
  }));
}

export function getProviderPriority() {
  return [...PROVIDER_PRIORITY];
}

export function setProviderPriority(priority) {
  if (priority && priority.length > 0) {
    PROVIDER_PRIORITY.length = 0;
    PROVIDER_PRIORITY.push(...priority);
  }
}

export function listProviderIds() {
  return Object.keys(PROVIDER_REGISTRY);
}

export { PROVIDER_REGISTRY, PROVIDER_PRIORITY };
